/**
 * @generated SignedSource<<765e268cc0a1e78b13a33e75f5550a5e>>
 * @relayHash 0e5febadf148cca119a3a0d78cb36fef
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 81fd6afd89e473aab00d07efa1a7ca5e6dc192c9fac1e00f986fb5eef38e2d47

import type { ConcreteRequest } from 'relay-runtime';
export type QuickFindSearchPerformedEventMutation$variables = {
  cloudId: string;
  query: string;
  resultCount: number;
  timestamp: string;
};
export type QuickFindSearchPerformedEventMutation$data = {
  readonly confluence_generateSearchPerformedEvent: {
    readonly success: boolean;
  } | null | undefined;
};
export type QuickFindSearchPerformedEventMutation = {
  response: QuickFindSearchPerformedEventMutation$data;
  variables: QuickFindSearchPerformedEventMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "query"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "resultCount"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "timestamp"
},
v4 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "query",
            "variableName": "query"
          },
          {
            "kind": "Variable",
            "name": "resultCount",
            "variableName": "resultCount"
          },
          {
            "kind": "Variable",
            "name": "timestamp",
            "variableName": "timestamp"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "ConfluenceGenerateSearchPerformedEventPayload",
    "kind": "LinkedField",
    "name": "confluence_generateSearchPerformedEvent",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "success"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "QuickFindSearchPerformedEventMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "QuickFindSearchPerformedEventMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "0e5febadf148cca119a3a0d78cb36fef",
    "id": "81fd6afd89e473aab00d07efa1a7ca5e6dc192c9fac1e00f986fb5eef38e2d47",
    "metadata": {},
    "name": "QuickFindSearchPerformedEventMutation",
    "operationKind": "mutation",
    "text": "mutation QuickFindSearchPerformedEventMutation($cloudId:ID!,$resultCount:Int!,$query:String!,$timestamp:String!){confluence_generateSearchPerformedEvent(cloudId:$cloudId,input:{resultCount:$resultCount,query:$query,timestamp:$timestamp}){success}}"
  }
};
})();

(node as any).hash = "3d3d464aa097e75cea744ba09799dccd";

export default node;
